import Bus from '@client/events/bus';
import Context from '@client/events/context';
import store from '@client/store';
import {Logger, Category} from '@simpleinvest/front-end-logger';
import {displayErrorBanner} from '@client/events/notification-bus';
import {BankLinkRequestStatus} from '@simpleinvest/ms-custodian-sdk';
import transfersService from '@client/services/transfers';

const logger = new Logger({
  category: Category.TransferMoney,
  fileName: 'bankLinks.ts',
});

export enum BankLinkEvents {
  BankLinkRequestComplete = 'BankLinkRequestComplete',
  TransferNewLinkRequestComplete = 'TransferNewLinkRequestComplete',
}

export interface BankLinksPayload {
  id: number;
  bankAccountId?: number;
}

export default {
  register(): void {
    Bus.$on(BankLinkEvents.BankLinkRequestComplete, async (payload: Context<BankLinksPayload>) => {
      try {
        await store.dispatch('transfers/updateBankLinkRequest', {
          requestId: payload.meta.id,
          status: BankLinkRequestStatus.Completed,
        });
      } catch (error) {
        logger.addBreadcrumb({
          callingFuncName: '$on(BankLinkRequestComplete)',
          message: `error updating bank link request: ${JSON.stringify(error)}`,
        });

        logger.logException({error});

        displayErrorBanner('Something went wrong while saving your bank link. Please try again later.');
      }
    });

    Bus.$on(BankLinkEvents.TransferNewLinkRequestComplete, async (payload: Context<BankLinksPayload>) => {
      try {
        await transfersService.updateRequestedTransfer({id: payload.meta.id, bankAccountId: payload.meta.bankAccountId});

        // Refresh the data.
        await store.dispatch('transfers/getRequestedTransfers');
      } catch (error) {
        logger.addBreadcrumb({
          callingFuncName: '$on(TransferNewLinkRequestComplete)',
          message: `error updating requested transfer: ${JSON.stringify(error)}`,
        });

        logger.logException({error});

        displayErrorBanner('Something went wrong while saving your bank link. Please try again later.');
      }
    });
  },
};
